<template>
  <div class="taskbar">
    <div class="start-button">
      <button class="btn start-btn" @click="onClickStart">
        <img src="https://win98icons.alexmeub.com/icons/png/windows-0.png" alt="Start" />
        <span>Start</span>
      </button>
      <transition name="start-menu">
        <div
          v-if="showStartMenu"
          class="start-menu"
        >
          <div class="start-menu-content">
            <!-- Left banner -->
            <div class="start-menu-banner">
              <img src="/start_banner.png" alt="Start Banner" />
            </div>
            <!-- Right menu items -->
            <div class="start-menu-items">
              <ul class="start-menu-list">
                <li>
                  <img src="https://win98icons.alexmeub.com/icons/png/directory_favorites-0.png" alt="Favorites" class="start-item-icon" />
                  Favorites
                  <span class="start-arrow">▶</span>
                </li>
                <li>
                  <img src="https://win98icons.alexmeub.com/icons/png/directory_open_file_mydocs-1.png" alt="Documents" class="start-item-icon" />
                  Documents
                  <span class="start-arrow">▶</span>
                </li>
                <li>
                  <img src="https://win98icons.alexmeub.com/icons/png/directory_explorer-2.png" alt="Find" class="start-item-icon" />
                  Find
                  <span class="start-arrow">▶</span>
                </li>
                <li>
                  <img src="https://win98icons.alexmeub.com/icons/png/help_book_cool-4.png" alt="Help" class="start-item-icon" />
                  Help
                </li>
                <li class="separator-start"></li>
                <li>
                  <img src="https://win98icons.alexmeub.com/icons/png/key_win_alt-2.png" alt="Log Off" class="start-item-icon" />
                  Log Off...
                </li>
                <li>
                  <img src="https://win98icons.alexmeub.com/icons/png/shut_down_normal-5.png" alt="Shut Down" class="start-item-icon" />
                  Shut Down...
                </li>
              </ul>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div class="open-windows">
      <button
        v-for="win in visibleWindows"
        :key="win.id"
        class="btn window-btn"
        :class="{ active: activeId === win.id }"
        @click="bringToFront(win.id)"
      >
        <img :src="win.icon" alt="icon" class="window-icon" />
        {{ win.label }}
      </button>
    </div>
    <div class="taskbar-space" />
    <div class="separator-small"></div>
    <div class="clock">{{ time }}</div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';

const props = defineProps({
  windows: Array,
  activeId: Number,
  onBringToFront: Function,
});

const time = ref('');
const showStartMenu = ref(false);

function updateClock() {
  const now = new Date();
  const h = now.getHours();
  const m = now.getMinutes();
  time.value = `${h}:${m.toString().padStart(2, '0')}`;
}

function onClickStart() {
  showStartMenu.value = !showStartMenu.value;
}

function handleClickOutside(event) {
  const startMenu = document.querySelector('.start-menu');
  const startButton = document.querySelector('.start-btn');
  if (
    startMenu &&
    !startMenu.contains(event.target) &&
    startButton &&
    !startButton.contains(event.target)
  ) {
    showStartMenu.value = false;
  }
}

onMounted(() => {
  updateClock();
  setInterval(updateClock, 60000);
  document.addEventListener('click', handleClickOutside);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside);
});

const visibleWindows = computed(() => {
  return props.windows.filter(win => !win.closed);
});

function bringToFront(id) {
  props.onBringToFront(id);
}
</script>

<style scoped>
/* Transizione per il menu Start */
.start-menu-enter-active,
.start-menu-leave-active {
  transition: all 0.3s ease-out;
}

.start-menu-enter-from,
.start-menu-leave-to {
  height: 0;
  overflow: hidden;
}

.start-menu-enter-to,
.start-menu-leave-from {
  height: 268px;
  overflow: hidden;
}

.start-arrow {
  margin-left: auto; 
  font-size: 12px;
  color: black;
}

.start-menu-list li:hover .start-arrow {
  color: white;
}

.taskbar {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 24px;
  width: 100%;
  background: #c0c0c0;
  border-top: 2px solid white;
  border-bottom: 2px solid #808080;
  display: flex;
  align-items: center;
  font-family: 'Pixelated MS Sans Serif', sans-serif;
}

.start-item-icon {
  width: 32px !important;
  height: 32px !important;
  object-fit: fill;
  image-rendering: pixelated;
}

.start-button {
  display: flex;
  align-items: center;
  margin-left: 2px;
  position: relative;
}

.start-btn {
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: 14px;
  font-weight: bold;
  height: 20px;
  padding-left: 5px;
  padding-right: 5px;
  width: 65px;
  min-width: 1px;
}

.start-btn img {
  width: 20px;
  height: 20px;
}

.start-menu {
  position: absolute;
  bottom: 24px;
  left: 0;
  width: 230px;
  background: #c0c0c0;
  border: 2px solid #808080;
  border-right-color: white;
  border-bottom-color: white;
  padding: 5px;
  box-shadow: 2px 2px 0px #000;
  overflow: hidden;
}

.start-menu-expand {
  height: 268px; /* Value based on the content height */
}

.start-menu-content {
  display: flex;
  flex-direction: row;
}

.start-menu-banner {
  width: 30px;
  background: #000080;
  display: flex;
  justify-content: center;
  align-items: center;
}

.start-menu-banner img {
  width: 100%;
  height: auto;
}

.start-menu-items {
  flex-grow: 1;
}

.start-menu-header {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px;
  background: #000080;
  color: white;
  font-size: 14px;
  font-weight: bold;
}

.start-menu-header img {
  width: 16px;
  height: 16px;
}

.start-menu-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.start-menu-list li {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 5px;
  font-size: 14px;
}

.start-menu-list li img {
  width: 16px;
  height: 16px;
}

.start-menu-list li:hover {
  background: #000080;
  color: white;
}

.start-menu-list .separator-start {
  height: 1px;
  padding: 0;
  background: #808080;
  margin: 5px 0;
}

.window-btn {
  display: flex;
  align-items: center;
  text-align: left;
  gap: 8px; /* Gap between icon and text*/
  padding: 1px 6px;
  width: 128px;
  height: 20px;
  font-size: 12px;
}

.window-icon {
  width: 16px;
  height: 16px;
  image-rendering: pixelated;
}

.separator-small {
  width: 1px;
  height: 20px;
  background: #868686;
  margin-left: 4px;
  margin-right: 4px;
}

.separator {
  min-width: 1px !important;
  min-height: 1px !important;
  height: 20px;
  margin-left: 0px;
  margin-right: 8px;
  padding: 2px;
  pointer-events: none;
}

.open-windows {
  display: flex;
  flex-direction: row;
  gap: 2px;
}

.taskbar-space {
  flex-grow: 1;
}

.clock {
  height: 10px;
  padding-right: 10px;
  font-size: 12px;
  color: black;
  background: #c0c0c0;
  border: 2px solid #808080;
  border-right-color: white;
  border-bottom-color: white;
  padding: 4px 8px;
  text-align: center;
  min-width: 60px;
}
</style>